import betshopDutch from "./rulesContent/CGUBetshopDutch.pdf";
import betshopFrench from "./rulesContent/CGUBetshopFrench.pdf";
import libraryDutch from "./rulesContent/CGULibraryDutch.pdf";
import libraryFrench from "./rulesContent/CGULibraryFrench.pdf";

const rules = {
  betshopDutch,
  betshopFrench,
  libraryDutch,
  libraryFrench,
};

export default {
  termsAndConditions: [
    {
      title: {
        fra: "1. Betshop",
        dut: "1. Betshop",
      },
      hasSubTabs: false,
      subTabs: [
        {
          title: {
            fra: "1.1 Normas Generales in Valencia",
            dut: "1. Normas Generales dut",
          },
          textSubTranslationKey: {
            fra: "1.1 Normas Generales in Valencia text",
            dut: "1. Normas Generales dut",
          },
        },
        {
          title: {
            fra: "1.1 Normas Generales in Valencia",
            dut: "1. Normas Generales dut",
          },
          textSubTranslationKey: {
            fra: "1.1 Normas Generales in Valencia text",
            dut: "1. Normas Generales dut",
          },
        },
      ],
      textTranslationKey: {
        fra: `<div><embed src="${rules.betshopFrench}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
        dut: `<div><embed src="${rules.betshopDutch}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
      },
    },
    {
      title: {
        fra: "2. Library",
        dut: "2. Library",
      },
      hasSubTabs: false,
      subTabs: [],
      textTranslationKey: {
        fra: `<div><embed src="${rules.libraryFrench}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
        dut: `<div><embed src="${rules.libraryDutch}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
      },
    },
  ],
};

// export default {
//     termsAndConditions: [
//         {
//             'title': {
//                 'eng': 'Rules',
//                 'rum': "Regulament de Joc"
//             },
//             'hasSubTabs': false,
//             'textTranslationKey': {
//                 'eng': `<div><embed src="${rules}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
//             }
//         }
//     ]
// };
